require('./dist/polyfill-locales')